
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { debitcard } from "../../../assets";


const DebitCard = () => {


  let navigate = useNavigate();

  return (
    <StyledDebitCard>
      <div className="row justify-content-around">
        <div className="col">
          <p>
            {/* Account Name */}
            ReniTrust ID
          </p>
          <h6 className='text-uppercase text-break'>
            AAAAAAAAA
          </h6>
        </div>
        <div className="col"
          title="Account Details">
          <p className='text-end'>
            AAAAAAAAAA
          </p>
          <h6 className='text-end pointer'
          >
            *********
            <br />
          </h6>
        </div>
      </div>
      <div className="row justify-content-around">
        <div className="col">
          <p>
            Current
          </p>
          <h4>
            AAAAAa
          </h4>
        </div>
        <div className="col text-end"
          title="Scan QR Code"
        >
          SAX
        </div>
      </div>
    </StyledDebitCard >
  );
};

export default DebitCard;

export const StyledDebitCard = styled.div`

  background: url(${ debitcard }) no-repeat ;
  margin: 0;
  background-size: cover;
  overflow-x: hidden;
  border-radius: 1rem;
  color: #ffffff !important;
  padding: 1rem;
  min-height:234px;
// height: 100%;
  display:flex;
  flex-direction:column;
  justify-content: space-between;

  img{
    width: 6rem ;
  }

  p{
    margin:0;
    font-size:10px;
    color: #FFFFFF4D;
  }

  svg {
    font-size: 40px;
  }

`;